(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('BatterySearch', BatterySearch);

    BatterySearch.$inject = ['$resource'];

    function BatterySearch($resource) {
        var resourceUrl =  'api/_search/batteries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
